import { render, staticRenderFns } from "./_ThirdLevelMenu.vue?vue&type=template&id=4d225003&"
import script from "./_ThirdLevelMenu.vue?vue&type=script&lang=ts&"
export * from "./_ThirdLevelMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d225003')) {
      api.createRecord('4d225003', component.options)
    } else {
      api.reload('4d225003', component.options)
    }
    module.hot.accept("./_ThirdLevelMenu.vue?vue&type=template&id=4d225003&", function () {
      api.rerender('4d225003', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/_ThirdLevelMenu.vue"
export default component.exports